import { Button, Menu, MenuItem } from "@material-ui/core";
import { createOrderUrl } from "@saleor/createOrder/urls";
import { useCustomerBlockContext } from "@saleor/customerBlock/hook/useCustomerBlockContext";
import useAppState from "@saleor/hooks/useAppState";
import useNavigator from "@saleor/hooks/useNavigator";
import { poUploadUrl } from "@saleor/poUpload/urls";
import classNames from "classnames";
import React, { useRef } from "react";
import SVG from "react-inlinesvg";

import ChipNumber from "../ChipNumber";
import MyTypography from "../MyTypography";
import useStyles from "./styles";

interface MenuItemsProps {
  menuItem: any;
  expanded: boolean;
  selected: boolean;
  isChildren?: boolean;
  onClick?: (id: string) => void;
}

const MenuItems: React.FC<MenuItemsProps> = ({
  menuItem,
  expanded,
  selected,
  isChildren,
  onClick
}) => {
  const classes = useStyles({ expanded });
  const refElement = useRef();
  const navigate = useNavigator();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const {
    customerBlockStatus,
    onOpenCustomerBlockDialog
  } = useCustomerBlockContext();

  const [_, dispatchAppState] = useAppState();

  const handleClose = () => {
    setAnchorEl(null);
    onClick("");
  };

  const handleResetOrderStateData = () => {
    dispatchAppState({
      payload: {
        filterOrderConfirm: {}
      },
      type: "setFilterOrderConfirm"
    });
    dispatchAppState({
      payload: {
        filterListSalesOrder: {}
      },
      type: "setFilterListSalesOrder"
    });
  };

  const handleClickMenuItem = items => {
    onClick(items?.id);

    if (items.url === createOrderUrl || items.url === poUploadUrl) {
      if (customerBlockStatus) {
        onOpenCustomerBlockDialog();
      } else {
        if (items.children && items.children.length) {
          setAnchorEl(refElement.current);
        } else {
          if (!items?.isRedirectLink) {
            navigate(items.url, { resetScroll: true });
            handleResetOrderStateData();
            handleClose();
            return;
          }
          window.open(items.url);
        }
      }
    } else {
      if (items.children && items.children.length) {
        setAnchorEl(refElement.current);
      } else {
        if (!items?.isRedirectLink) {
          navigate(items.url, { resetScroll: true });
          handleResetOrderStateData();
          handleClose();
          return;
        }
        window.open(items.url);
      }
    }
  };

  return (
    <div className={classes.rootMenuItem}>
      {!isChildren ? (
        <Button
          className={classNames(classes.menuItem, selected ? "active" : "")}
          onClick={() => handleClickMenuItem(menuItem)}
          ref={refElement}
        >
          <>
            <SVG src={menuItem.iconSrc} className={classes.menuIcon} />
            <div className={classes.menuLabel}>
              {menuItem.label}
              {menuItem.subLabel && (
                <div className={classes.subLabel}>{menuItem.subLabel}</div>
              )}
            </div>
          </>
        </Button>
      ) : (
        <Button onClick={() => handleClickMenuItem(menuItem)} ref={refElement}>
          <MyTypography
            variant="body2"
            style={{
              width: "100%",
              padding: "0px",
              minHeight: "auto"
            }}
            className={classNames(classes.childrenMenu)}
          >
            {menuItem.label}
          </MyTypography>
        </Button>
      )}
      <>
        {menuItem.children && menuItem.children.length ? (
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            disableAutoFocusItem
            onClose={handleClose}
            getContentAnchorEl={null}
            anchorOrigin={
              isChildren
                ? { vertical: "center", horizontal: "right" }
                : { vertical: "top", horizontal: "right" }
            }
            transitionDuration={500}
            PaperProps={{
              className: classes.paperMenu
            }}
            MenuListProps={{
              className: classes.parentMenu
            }}
          >
            {menuItem.children.map(children => (
              <MenuItem
                key={children.id}
                onClick={() => handleClickMenuItem(children)}
                className={classes.childrenMenu}
              >
                {children.children ? (
                  <MenuItems
                    menuItem={children}
                    expanded={expanded}
                    selected={selected}
                    onClick={onClick}
                    isChildren={true}
                  />
                ) : (
                  children.label
                )}
              </MenuItem>
            ))}
          </Menu>
        ) : (
          ""
        )}
        {menuItem?.notifyChip ? (
          <ChipNumber
            number={menuItem?.notifyChip}
            classesChip={classes.chipClass}
          />
        ) : (
          ""
        )}
      </>
    </div>
  );
};

export default MenuItems;
